import { createContext, useContext } from 'react';

/** The delivered-products outcome filter, held in the hosting route's URL (`dout`). */
export interface DeliveryOutcomeParam {
  value: string | null;
  onChange: (outcomeId: string | null) => void;
}

/**
 * Lets `DeliveryRunProducts` keep its outcome filter in the URL wherever it renders (Delivery tab,
 * Overview's Publish step) without threading props through the publishing sections. Provided by
 * those routes; `null` elsewhere, where the filter stays local.
 */
export const DeliveryOutcomeCtx = createContext<DeliveryOutcomeParam | null>(null);

/** Reads the route's outcome param, or null with no provider above. */
export function useDeliveryOutcomeParam(): DeliveryOutcomeParam | null {
  return useContext(DeliveryOutcomeCtx);
}
